import { Component, Input, OnChanges, OnDestroy } from "@angular/core"
import { CollectionNode } from "../../../models/collectionNode.model"
import { Colors } from "../../../models/colors.model"
import { ColorCodeService } from "../../../services/color-code.service"
import { StudentGateService } from "../../../services/student-gate.service"
import Utils from "../../../utils/utils"
import { IWindowResizeEvent, WindowSizeService } from "../../../services/window-size.service"
import { Observable, Subject } from "rxjs"
import { takeUntil, tap } from "rxjs/operators"

@Component({
    selector: "app-info-bar",
    templateUrl: "./info-bar.component.html",
    styleUrls: ["./info-bar.component.scss"],
    standalone: false,
})
export class InfoBarComponent implements OnChanges, OnDestroy {
    @Input() activeCollection: CollectionNode
    @Input() parentCollection: CollectionNode
    @Input() isCollectionPreview: boolean = false
    private styles: Colors
    private destroyed$: Subject<void> = new Subject<void>()

    gradesOptions: any[] = []
    breadCrumbs: unknown[] = []
    isStudentExperience: boolean = false
    innerWidth: number

    windowResizeEventObservable: Observable<IWindowResizeEvent> =
        this.windowSizeService.resize.pipe(
            takeUntil(this.destroyed$),
            tap((resizeEvent: IWindowResizeEvent) => (this.innerWidth = resizeEvent.innerWidth))
        )

    gradeChangeObservable: Observable<string> = this.studentGateService.selectedGradeState.pipe(
        takeUntil(this.destroyed$),
        tap(() => (this.gradesOptions = this.studentGateService.collectionGradeOptions))
    )

    constructor(
        private colorCodeService: ColorCodeService,
        private studentGateService: StudentGateService,
        private windowSizeService: WindowSizeService
    ) {}

    ngOnInit(): void {
        this.gradeChangeObservable.subscribe()
        this.windowResizeEventObservable.subscribe()
        this.isStudentExperience = Utils.hasStudentExperience()
    }

    changeGradeOptions(selectedValue: string): void {
        this.studentGateService.setSelectedCollectionGradeOption(selectedValue)
    }

    get displayResourceDetails(): boolean {
        if (this.innerWidth > 992 && !this.isStudentExperience) {
            return true
        } else return this.isStudentExperience
    }

    public ngOnChanges(): void {
        this.breadCrumbs = this.activeCollection.generateBreadcrumbs(
            Utils.hasStudentExperience(),
            this.isCollectionPreview
        )
        this.styles = this.parentCollection.style
    }

    public getColor(): { background: string; color: string } {
        if (this.styles.isEnabled) {
            return {
                background: this.styles.colorBkgd,
                color: this.styles.colorText,
            }
        }
        return {
            background: this.colorCodeService.collectionColors.defaultBackgroundColor,
            color: this.colorCodeService.collectionColors.defaultTextColor,
        }
    }
    public getCollectionSlug(): string {
        if (this.activeCollection.slug.includes("/")) {
            //first element after split is parent slug
            return this.activeCollection.slug.split("/")[0]
        } else {
            return this.activeCollection.slug
        }
    }

    ngOnDestroy(): void {
        this.destroyed$.next()
        this.destroyed$.complete()
    }
}
